import React from 'react';

// Conteúdo do modal "O que significam as cores?" (botão ao lado das abas
// Ativas/Desativadas em GerenciarEnquetes.js) — cada item usa a mesma borda
// + animação de pulso do card de verdade (ver classeBordaStatus lá e as
// keyframes pulseBorder* em index.css), só num quadrado pequeno, pra quem
// olhar reconhecer exatamente a cor que via nos cards.
const ITENS = [
  {
    classe: 'border-red-500/45 animate-pulse-red',
    titulo: 'Vermelha',
    descricao: 'Privada e sem nenhuma pergunta criada ainda — formulário vazio, esquecido.'
  },
  {
    classe: 'border-orange-500/45 animate-pulse-orange',
    titulo: 'Laranja',
    descricao: 'Privada, mas já tem pergunta — pronta, só falta configurar e tornar pública.'
  },
  {
    classe: 'border-amber-400/45 animate-pulse-yellow',
    titulo: 'Amarela',
    descricao: 'Pública em rascunho — funciona como link de prévia (ver "Compartilhar Link"), mas votação e resultado continuam bloqueados até publicar.'
  },
  {
    classe: 'border-emerald-500/45 animate-pulse-green',
    titulo: 'Verde',
    descricao: 'Pública e com status "Publicada" — votação aberta pra qualquer visitante.'
  },
  {
    classe: 'border-blue-500/45 animate-pulse-blue',
    titulo: 'Azul',
    descricao: 'Pública e com status "Encerrada" — não aceita mais voto, mas continua visível/arquivada.'
  }
];

const LegendaCoresModal = () => (
  <div className="space-y-4">
    <p className="text-sm text-gray-500">
      A borda pulsante de cada enquete (só na aba Ativas) resume visibilidade + status + perguntas sem precisar ler o card inteiro.
    </p>
    <ul className="space-y-3">
      {ITENS.map((item) => (
        <li key={item.titulo} className="flex items-start gap-3">
          <span className={`w-9 h-9 rounded-lg bg-white border-2 flex-shrink-0 ${item.classe}`} />
          <div>
            <p className="text-sm font-semibold text-gray-900">{item.titulo}</p>
            <p className="text-sm text-gray-500">{item.descricao}</p>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default LegendaCoresModal;
